<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Usuários e Profissionais</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="up"
          :total="total"
          :hideSearch="true"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import usuariosprofissionaisService from '@/services/usuariosprofissionais'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'

export default {
  name: 'usuarioprofissional',
  components: {
    EDataTable
  },
  data () {
    return {
      up: [],
      total: 0,
      headers: [
        { text: 'Usuário', value: 'usuario', sortable: false },
        { text: 'Profissional', value: 'profissional', sortable: false }],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        this.loading = true
        const result = search === '' ? await usuariosprofissionaisService.getAll(page) : await usuariosprofissionaisService.getByNome(search, page)
        this.total = result._meta.total_items
        this.up = result.data
        this.loading = false
      } catch (error) {
        this.viagens = []
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Usuários Profissionais', 'alterar')
      if (ret === true) {
        this.$router.push(`/usuariosprofissionais/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Usuários Profissionais', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover relacionamento ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await usuariosprofissionaisService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Usuários Profissionais', 'incluir')
      if (ret === true) {
        this.$router.push(`/usuariosprofissionais/criar`)
      }
    }
  }
}
</script>
